/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the Sede interface.
 */
export function instanceOfSede(value) {
    return true;
}
export function SedeFromJSON(json) {
    return SedeFromJSONTyped(json, false);
}
export function SedeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'denominazione': json['denominazione'] == null ? undefined : json['denominazione'],
    };
}
export function SedeToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'denominazione': value['denominazione'],
    };
}
